$(function() {
    $(document).on('click', '*[role="tab"]', function (e) {
        e.preventDefault();
        var targetId = $(this).find('a').attr('href');
        var $target = $(targetId);

        $(this).parents('.tabs, .menu-list').find('*[role="tab"]').removeClass('is-active');
        $(this).addClass('is-active');
        $target.parent('.tab-content').children('.tab-page').removeClass('is-active');
        $target.addClass('is-active');

        loadResources();
        loadImages();
    });
});